module.exports = __webpack_public_path__ + "static/media/scan.3c1438cb.svg";